<template>
  <div>
    <b-table
      class="text-center table-list mb-0"
      empty-text="ไม่พบข้อมูล"
      :fields="fields"
      :items="items"
      :busy="busy"
      show-empty
      striped
      responsive
      sticky-header
    >
      <!-- sticky-header -->
      <!-- show-empty
      striped
      responsive
      -->
      <!-- header -->

      <!-- end -->

      <!-- body -->

      <template v-slot:cell(employeeId)="data">
        <p class="m-0">
          {{ data.item.employeeId || "-" }}
        </p>
      </template>

      <template v-slot:cell(createdTime)="data">
        <p class="m-0">
          {{ new Date(data.item.createdTime) | moment($formatDateTime) }}
        </p>
      </template>

      <template v-slot:cell(enabled)="data">
        <p class="m-0 text" :class="colorStatus(data.item.enabled)">
          {{ textStatus(data.item.enabled) }}
        </p>
      </template>

      <template v-slot:cell(userGUID)="data">
        <font-awesome-icon
          class="pointer"
          icon="pencil-alt"
          @click="goDetailPage(data.item)"
        />
      </template>

      <!-- end -->

      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "employeeId",
          label: `รหัสพนักงาน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "email",
          label: `อีเมล`,
          class: "w-100px text-nowrap",
        },
        {
          key: "firstname",
          label: `ชื่อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "lastname",
          label: `นามสกุล`,
          class: "w-100px text-nowrap",
        },
        {
          key: "createdTime",
          label: `วันที่ทำการสมัคร`,
          class: "w-100px text-nowrap",
        },
        {
          key: "enabled",
          label: `สถานะ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "userGUID",
          label: ``,
          class: "w-100px text-nowrap",
        },
      ],
    };
  },
  methods: {
    goDetailPage(obj) {
      this.$emit("editUser", obj);
    },
    colorStatus(value) {
      let color = "";

      if (value) {
        color = "green";
      } else {
        color = "red";
      }

      return color;
    },
    textStatus(value) {
      let text = "";

      if (value) {
        text = "ใช้งาน";
      } else {
        text = "ปิดการใช้งาน";
      }

      return text;
    },
  },
};
</script>

<style scoped>
.text.red {
  color: red;
}
.text.green {
  color: green;
}
.pointer:hover {
  color: #b41bb4 !important;
}
</style>
